module.exports = __webpack_public_path__ + "static/img/award5_active.03ddf83.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/index/award5_active.png
// module id = bF1I
// module chunks = 7